import React, { useEffect, useState } from 'react'
import { IconButton, useMediaQuery } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { WrapSideBar, DrawerStyles, SideBarStyles } from './Style'
import { sidebarHooks } from '.';
import { useDispatch } from 'react-redux';
import { actions } from 'store';
import { SideBarItems } from '.'
import { CacheProvider } from '@emotion/react';
import { cacheLtr } from 'styles/theme';

const SideBar = () => {
    const [open, setOpen] = useState(false);
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'), { noSsr: true })

    const dispatch = useDispatch()

    const menuItems = sidebarHooks.useMenuItems()
    const handleMenuItem = sidebarHooks.useHandleMenuItem()
    const { pathname } = useLocation()
    const navigate = useNavigate()

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };

    const cleanData = () => {
        dispatch(actions.setTestTaker({}))
        dispatch(actions.setAssessment({}))
    }

    useEffect(() => {
        handleMenuItem(menuItems)
    }, [pathname])

    return (
        <SideBarStyles>
            {isSmallScreen ? (
                <div>
                    <IconButton className='drawer-button' edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                        <Menu />
                    </IconButton>
                    <CacheProvider value={cacheLtr}>
                        <DrawerStyles anchor='right' open={open} onClose={toggleDrawer(false)}>
                            <SideBarItems closeDrawer={toggleDrawer(false)} />
                        </DrawerStyles>
                    </CacheProvider>
                </div>
            ) :
                <WrapSideBar>
                    <SideBarItems />
                </WrapSideBar>
            }
        </SideBarStyles>
    )
}

export default SideBar